import React from "react";
import { generateUniqueID } from "web-vitals/dist/modules/lib/generateUniqueID";
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom";

import ServicesEn from "./components/services/services-en";
import ServicesRu from "./components/services/services-ru";
import ServicesCn from "./components/services/services-cn";
import Category from "./components/category/category";
import ProjectsEn from  '../src/data/projects-en.json';
import ProjectsRu from  '../src/data/projects-ru.json';
import ProjectsCn from  '../src/data/projects-cn.json';

function App() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const cn = params.lang && (params.lang === 'cn');
  const eng = (window.lang && window.lang === 'en') || (params.lang === 'en');

  const projects = eng ? ProjectsEn : cn ? ProjectsCn : ProjectsRu;
  const services = eng ? ServicesEn : cn ? ServicesCn : ServicesRu;

  return (
    <Router>
      <Switch>
        <Route exact path="/competencies" component={services}/>
        {
          Object.entries(projects).map(project => {
            const tag = project[0];
            return (
              <Route exact key={generateUniqueID()} path={"/competencies/" + tag}>
                <Category tag={tag} />
              </Route>
            );
          })
        }
      </Switch>
    </Router>
  );
}

export default App;
